import { render, staticRenderFns } from "./CollectionItemActions.vue?vue&type=template&id=23bd104e&scoped=true&"
import script from "./CollectionItemActions.vue?vue&type=script&lang=js&"
export * from "./CollectionItemActions.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItemActions.vue?vue&type=style&index=0&id=23bd104e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd104e",
  null
  
)

export default component.exports